const ASSET_MIME = 'application/x-studio-asset';
const PLAIN_PREFIX = 'studio-asset:';

export const setAssetDragData = (event, assetId) => {
  if (!event?.dataTransfer || !assetId) return;
  try {
    event.dataTransfer.setData(ASSET_MIME, JSON.stringify({ assetId }));
    event.dataTransfer.setData('text/plain', `${PLAIN_PREFIX}${assetId}`);
    event.dataTransfer.effectAllowed = 'copy';
  } catch (error) {
    // Ignore drag data failures.
  }
};

export const getAssetDragData = (event) => {
  if (!event?.dataTransfer) return null;
  const raw = event.dataTransfer.getData(ASSET_MIME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.assetId) {
      return parsed;
    }
  } catch (error) {
    return null;
  }
  return null;
};

export const hasAssetDragData = (event) => {
  if (!event?.dataTransfer) return false;
  const types = Array.from(event.dataTransfer.types || []);
  if (types.includes(ASSET_MIME)) return true;
  return types.includes('text/plain');
};

export const getAssetDragDataFromPlain = (event) => {
  if (!event?.dataTransfer) return null;
  const text = event.dataTransfer.getData('text/plain');
  if (typeof text !== 'string' || !text.startsWith(PLAIN_PREFIX)) return null;
  return { assetId: text.replace(PLAIN_PREFIX, '') };
};
